import { render, staticRenderFns } from "./Sources.vue?vue&type=template&id=21d27ba8&scoped=true"
import script from "./Sources.vue?vue&type=script&lang=js"
export * from "./Sources.vue?vue&type=script&lang=js"
import style0 from "./Sources.vue?vue&type=style&index=0&id=21d27ba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d27ba8",
  null
  
)

export default component.exports